import type { SelectChangeEvent } from "@mui/material";
import type { Dispatch, SetStateAction } from "react";
import type { ControlType, FormType } from "../../components/types";

export const handlePairingFormControlChange = (
  event: SelectChangeEvent,
  index: number,
  setForms: Dispatch<SetStateAction<FormType[]>>,
) => {
  setForms(state => {
    const copy: FormType[] = [...state];
    const formToUpdate = copy[index];
    formToUpdate.control = event.target.value as ControlType;
    return copy;
  });
};
